var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('LandMap',{attrs:{"landList":_vm.landList,"trajectoryList":_vm.trajectoryList,"mapTopInfoOptions":_vm.mapTopInfoOptions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }